import Vue from 'vue';
import App from './App.vue';
import router from './router';

Vue.config.productionTip = false;

import '@/directives/index';
import './vendor';
import '@/init-axios';

import '@/styles.scss';
import '@/codey-prime/primevue.scss';

import { XerIcon } from '@xerius/codey-components-vue2';
import xerIconsPlugin from '@xerius/codey-icons-vue2';

// import VueCompositionAPI from '@vue/composition-api';
// import { VueQueryPlugin } from 'vue-query';
import { createPinia, PiniaVuePlugin } from 'pinia';
import registerRouteChanged from '@/router/register-route-changed';
import { useRootStore } from '@/stores/index';
import { VueQueryPlugin } from '@tanstack/vue-query';
import { useLeadAanvraagStore } from '@/stores/lead-aanvraag/lead-aanvraag';
import { useNotificationsStore } from '@/stores/notification/notification';
import { useStapConfigStore } from '@/stores/stap-config/stap-config';

import PrimeVue from 'primevue/config';
Vue.use(PrimeVue);

Vue.component(XerIcon.name, XerIcon);
Vue.use(xerIconsPlugin);
// Vue.use(VueCompositionAPI);
Vue.use(VueQueryPlugin);
Vue.use(PiniaVuePlugin);

const pinia = createPinia();
//TODO is this stil needed?
// pinia.use(({ store }) => {
//   store.router = markRaw(router);
// });
router.beforeEach(async (to, from, next) => {
  registerRouteChanged(to, pinia);
  next();
});

const app = new Vue({
  router,
  pinia,
  mounted() {
    const rootStore = useRootStore(pinia);
    rootStore.setIsMobile(this.$device.mobile);
  },
  render: (h) => h(App)
}).$mount('#app');

if (window.Cypress) {
  // eslint-disable-next-line no-console
  console.info('Vue App exposesed on window.app for testing puroses');
  window.app = app;
  const leadAanvraagStore = useLeadAanvraagStore();
  const notificationStore = useNotificationsStore();
  const stapConfigStore = useStapConfigStore();
  window.stores = { leadAanvraagStore, notificationStore, stapConfigStore };
  window.router = router;
}
